/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface WaveMetadataDto
 */
export interface WaveMetadataDto {
    /**
     *
     * @type {string}
     * @memberof WaveMetadataDto
     */
    metadata?: string;
}

/**
 * Check if a given object implements the WaveMetadataDto interface.
 */
export function instanceOfWaveMetadataDto(
    value: object,
): value is WaveMetadataDto {
    return true;
}

export function WaveMetadataDtoFromJSON(json: any): WaveMetadataDto {
    return WaveMetadataDtoFromJSONTyped(json, false);
}

export function WaveMetadataDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): WaveMetadataDto {
    if (json == null) {
        return json;
    }
    return {
        metadata: json["metadata"] == null ? undefined : json["metadata"],
    };
}

export function WaveMetadataDtoToJSON(value?: WaveMetadataDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        metadata: value["metadata"],
    };
}
